(function ($) {
    $.fn.adzScrollToElement = function (args) {

        var defaultArgs = {
            topElement: $('.header'),
            offsetFromTopElement: 0,
            speed: 1000
        };

        args = jQuery.extend({}, defaultArgs, args);

        var topElementH;

        if (args[['topElement']].length) {
            topElementH = $(args['topElement']).outerHeight();
        } else {
            topElementH = 0;
        }

        $('html, body').animate({
            scrollTop: $(this).offset().top - topElementH - args['offsetFromTopElement']
        }, args['speed']);
    };
})(jQuery);

